const LOWERCASE = 'abcdefghjkmnpqrstuvwxyz';
const UPPERCASE = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const DIGITS = '23456789';
const SPECIALS = '@#$%!^*&';
const ALL = LOWERCASE + UPPERCASE + DIGITS + SPECIALS;

const randomChar = (source) => source[Math.floor(window.crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296 * source.length)];

const shuffle = (chars) => {
  const result = [...chars];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const randomIndex = window.crypto.getRandomValues(new Uint32Array(1))[0] % (i + 1);
    [result[i], result[randomIndex]] = [result[randomIndex], result[i]];
  }
  return result.join('');
};

export const generateCompliantPassword = (length = 16) => {
  const targetLength = Math.max(16, Math.min(length, 20));
  const requiredChars = [
    randomChar(LOWERCASE),
    randomChar(UPPERCASE),
    randomChar(DIGITS),
    randomChar(SPECIALS),
  ];

  while (requiredChars.length < targetLength) {
    requiredChars.push(randomChar(ALL));
  }

  return shuffle(requiredChars);
};

export const validatePassword = (password) => {
  if (!password) return 'Password is required';
  if (password.length < 16 || password.length > 20)
    return 'Password must be 16-20 characters';
  if (!/[a-z]/.test(password)) return 'Password must include a lowercase letter';
  if (!/[A-Z]/.test(password)) return 'Password must include an uppercase letter';
  if (!/[0-9]/.test(password)) return 'Password must include a number';
  if (!/[@#$%!^*&]/.test(password)) return 'Password must include one of @#$%!^*&';
  return null;
};

export const passwordPolicyHint =
  'Password must be 16-20 characters and include uppercase, lowercase, number, and one of @#$%!^*&.';
